/**
 * Copyright ©2022 Drivepoint
 */

import {LicenseInfo} from "@mui/x-license";

export default class Licenses {

  static init(): void {
    LicenseInfo.setLicenseKey(
      "b76b066f4523efda5d0c00394b308cf2Tz0xMzE5OTMsRT0xODE4Mjg3OTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9UTEtMjAyNixRPTEsQVQ9c2luZ2xlLEtWPTI="
    );
  }

}
